const productVariation = {
    hasInitialized: false,
    isLoading: false,
    list: {},
    listDisplay: [],
    listParams: {
        filters: {},
        activePage: 1,
        perPage: 9999,
        totalRecords: 1,
        sortBy: 'URLSegment',
        sortDirection: 'ASC',
    },
    relatedProductList: {},
};
const ProductVariationReducer = function(state = productVariation, action) {
    switch (action.type) {
        case 'UPDATE_PRODUCT_VARIATION_LIST_HAS_INITIALIZED': {
            return {
                ...state,
                hasInitialized: action.value,
            };
        }
        case 'TOGGLE_PRODUCT_VARIATION_LIST_LOADING': {
            return {
                ...state,
                isLoading: action.value,
            };
        }
        case 'UPDATE_PRODUCT_VARIATION_LIST': {
            let newList = { ...state.list };

            Object.entries(action.value).map(([key, value]) => {
                newList[key] = {
                    ...newList[key],
                    ...value,
                };
            });

            return {
                ...state,
                list: newList,
            };
        }
        case 'REPLACE_PRODUCT_VARIATION_LIST': {
            return {
                ...state,
                list: action.value,
            };
        }
        case 'UPDATE_PRODUCT_VARIATION_RELATED_PRODUCT_LIST': {
            let newList = { ...state.relatedProductList };

            Object.entries(action.value).map(([key, value]) => {
                newList[key] = {
                    ...newList[key],
                    ...value,
                };
            });

            return {
                ...state,
                relatedProductList: newList,
            };
        }
        case 'UPDATE_PRODUCT_VARIATION_LIST_DISPLAY': {
            return {
                ...state,
                listDisplay: action.value,
            };
        }
        case 'UPDATE_PRODUCT_VARIATION_LIST_FILTERS': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    filters: action.value,
                },
            };
        }
        case 'UPDATE_PRODUCT_VARIATION_LIST_SORT': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    sortBy: action.value,
                    sortDirection: action.direction,
                },
            };
        }
        case 'SET_PRODUCT_VARIATION_LIST_ACTIVE_PAGE': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    activePage: action.value,
                },
            };
        }
        case 'SET_PRODUCT_VARIATION_LIST_TOTAL_RECORDS': {
            return {
                ...state,
                listParams: {
                    ...state.listParams,
                    totalRecords: action.value,
                },
            };
        }
        default: {
            return state;
        }
    }
};

export default ProductVariationReducer;
